import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isText: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if(charCode == 32 || charCode == 209 || charCode == 241 || (65 <= charCode && charCode <= 90) || (97 <= charCode && charCode <= 122)) {
        return true;
      } else {
        evt.preventDefault();
        return false;
      }
    },
    drowMap(cordy, cordx, centro) {
      let map = new mapboxgl.Map({
        container: 'lmap',
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [cordy, cordx],
        zoom: 15
      });
      map.addControl(new mapboxgl.NavigationControl());
      map.doubleClickZoom.disable();
      let popup = new mapboxgl.Popup({ offset: 33 })
      .setText(centro);
      new mapboxgl.Marker()
        .setLngLat([cordy, cordx])
        .setPopup(popup)
        .addTo(map);
    }
  }
});

/* Vue.directive('numberonly', (el) => {console.log(el);
  if (!/^\+?(0|[1-9]\d*)$/.test(el.value) && el.value) {
    el.value = el.value.replace(/[a-zA-Z]+/ig, '');
  }
}); */

Vue.filter('formatdate', function (value) {
  if (!value) return ''
  return value.substring(0, 10).split('-').reverse().join('/');
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
